import {ItemType} from "../Data/ItemModel";
import {GlockenspielActivity} from "./Music/GlockenspielActivity";
import {Dict} from "../Core/Reflection";
import {AbstractHomeActivity} from "./AbstractHomeActivity";
import {NyatitiActivity} from "./Music/NyatitiActivity";
import {Overlay} from "./Overlay";
import {DidgeridooActivity} from "./Music/DidgeridooActivity";
import {BagpipesActivity} from "./Music/BagpipesActivity";
import {HomeScreen} from "../States/HomeScreen";

export const HomeScreenActivities: Dict<ItemType, new (screen: HomeScreen) => AbstractHomeActivity> = {
    [ItemType.Glockenspiel]: GlockenspielActivity,
    [ItemType.Nyatiti]: NyatitiActivity,
    [ItemType.Didgeridoo]: DidgeridooActivity,
    [ItemType.Bagpipes]: BagpipesActivity,
}